import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';

import { STYLES } from '@/define/olMaps';
import { createFenceFeatures } from '@/utils/FenceUtil';

/**
 * Fence(지오펜스) 영역 관리 Feature
 */
class FenceFeature {
  constructor(map) {
    this.map = map;
    this.fences = {};
  }

  /**
   * Fence 추가
   * @param {string} robotId - 로봇 ID
   * @param {Array} fences - fence 데이터 배열
   * @param {string} color - 색상
   */
  add(robotId, fences, color) {
    const features = createFenceFeatures(fences);
    const source = new VectorSource({ features });
    const layer = new VectorLayer({
      source,
      style: STYLES.ZONE('Geofence', color),
    });

    this.map.addLayer(layer);
    this.fences[robotId] = layer;
  }

  /**
   * Fence 제거
   * @param {string} robotId - 로봇 ID
   */
  remove(robotId) {
    if (!this.fences[robotId]) return;

    this.map.removeLayer(this.fences[robotId]);
    delete this.fences[robotId];
  }

  /**
   * Fence 데이터 가져오기
   * @param {string} robotId - 로봇 ID
   * @returns {VectorLayer|undefined} Fence 레이어
   */
  get(robotId) {
    return this.fences[robotId];
  }
}

export default FenceFeature;
